"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var Timer_1 = __importDefault(require("../../Timer"));
var ToastController = /** @class */ (function (_super) {
    __extends(ToastController, _super);
    function ToastController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isRunning: Boolean(_this.props.autoDismiss)
        };
        _this.startTimer = function () {
            var _a = _this.props, autoDismiss = _a.autoDismiss, autoDismissTimeout = _a.autoDismissTimeout, onDismiss = _a.onDismiss;
            if (!autoDismiss) {
                return;
            }
            _this.setState({ isRunning: true });
            _this.timeout = new Timer_1["default"](onDismiss, autoDismissTimeout);
            _this.timeout.resume();
        };
        _this.clearTimer = function () {
            if (_this.timeout) {
                _this.timeout.clear();
            }
        };
        _this.onMouseEnter = function () {
            _this.setState({ isRunning: false }, function () {
                if (_this.timeout) {
                    _this.timeout.pause();
                }
            });
        };
        _this.onMouseLeave = function () {
            _this.setState({ isRunning: true }, function () {
                if (_this.timeout) {
                    _this.timeout.resume();
                }
            });
        };
        return _this;
    }
    ToastController.prototype.componentDidMount = function () {
        this.startTimer();
    };
    ToastController.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.autoDismiss !== this.props.autoDismiss) {
            var startOrClear = this.props.autoDismiss
                ? this.startTimer
                : this.clearTimer;
            startOrClear();
        }
    };
    ToastController.prototype.componentWillUnmount = function () {
        this.clearTimer();
    };
    ToastController.prototype.render = function () {
        var _a = this.props, autoDismiss = _a.autoDismiss, autoDismissTimeout = _a.autoDismissTimeout, Toast = _a.component, props = __rest(_a, ["autoDismiss", "autoDismissTimeout", "component"]);
        var isRunning = this.state.isRunning;
        var handleMouseEnter = autoDismiss ? this.onMouseEnter : null;
        var handleMouseLeave = autoDismiss ? this.onMouseLeave : null;
        return (react_1["default"].createElement(Toast, __assign({ autoDismiss: autoDismiss, autoDismissTimeout: autoDismissTimeout, isRunning: isRunning, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, props)));
    };
    ToastController.defaultProps = {
        autoDismiss: false
    };
    return ToastController;
}(react_1.Component));
exports["default"] = ToastController;
